import { safeMapToEntity } from "@/data/repo-Implement/safe-map-to-entity";
import { PreRegistrationEncyptedPayload } from "@/data/payload/pre-registration-request-payload";
import { PreRegistrationSource } from "@/data/source/pre-registration-source";
import { PreRegistrationPatientInfoEntity } from "@/domain/entity/pre-regitration-patient-info-entity";
import { PreRegistrationRepository } from "@/domain/repository/pre-registration-repository";
import { SATError, SATResult } from "@sadtx/sat-error";
import { PreRegistrationPatientInfoListMapper } from "../mapper/pre-registration-patient-info-list-mapper";
import { PreRegistrationPatientInfoMapper } from "../mapper/pre-registration-patient-info-mapper";

/**
 * 사전 등록 리포지토리 구현체
 */
export class PreRegistrationRepositoryImpl implements PreRegistrationRepository {
  constructor(private readonly source: PreRegistrationSource) {}

  /**
   * 환자 및 보호자 사전 등록
   * @param payload - 암호화된 사전 등록 정보
   * @returns 성공 시 void, 실패 시 SATError
   */
  async createPreRegistration(
    token: string,
    payload: PreRegistrationEncyptedPayload
  ): Promise<SATResult<void, SATError>> {
    console.log("[PreRegistrationRepositoryImpl] :: createPreRegistration :: 사전 등록 시작");
    const result = await this.source.createPreRegistration(token, payload);

    if (result.isFailure) {
      console.error(
        "[PreRegistrationRepositoryImpl] :: createPreRegistration :: 사전 등록 실패",
        result.error
      );
      return SATResult.failure(result.error);
    }

    console.log("[PreRegistrationRepositoryImpl] :: createPreRegistration :: 사전 등록 성공");
    return SATResult.success(void 0);
  }

  /**
   * 사전 등록 정보 조회
   * @param token - 사전 등록 토큰
   * @returns 성공 시 PreRegistrationInfoResponseDto, 실패 시 SATError
   */
  async getPreRegistrationList(): Promise<
    SATResult<PreRegistrationPatientInfoEntity[], SATError>
  > {
    console.log(
      "[PreRegistrationRepositoryImpl] :: getPreRegistration :: 사전 등록 정보 조회 시작"
    );
    const result = await this.source.getPreRegistrationList();

    if (result.isFailure) {
      console.error(
        "[PreRegistrationRepositoryImpl] :: getPreRegistration :: 사전 등록 정보 조회 실패",
        result.error
      );
      return SATResult.failure(result.error);
    }

    console.log(
      "[PreRegistrationRepositoryImpl] :: getPreRegistration :: 사전 등록 정보 조회 성공"
    );
    return safeMapToEntity(
      result.value,
      PreRegistrationPatientInfoListMapper.toEntity,
      "PreRegistrationRepositoryImpl::getPreRegistrationList"
    );
  }

  async getPreRegistrationPatientInfo(
    uuid: string
  ): Promise<SATResult<PreRegistrationPatientInfoEntity, SATError>> {
    console.log(
      "[PreRegistrationRepositoryImpl] :: getPreRegistrationPatientInfo :: 사전 등록 환자 정보 조회 시작",
      uuid
    );
    const result = await this.source.getPreRegistrationPatientInfo(uuid);

    if (result.isFailure) {
      console.error(
        "[PreRegistrationRepositoryImpl] :: getPreRegistrationPatientInfo :: 사전 등록 환자 정보 조회 실패",
        result.error
      );
      return SATResult.failure(result.error);
    }

    console.log(
      "[PreRegistrationRepositoryImpl] :: getPreRegistrationPatientInfo :: 사전 등록 환자 정보 조회 성공"
    );
    return safeMapToEntity(
      result.value,
      PreRegistrationPatientInfoMapper.toEntity,
      "PreRegistrationRepositoryImpl::getPreRegistrationPatientInfo"
    );
  }

  /**
   * 사전 등록 정보 수정
   * @param token - 사전 등록 토큰
   * @param payload - 수정할 사전 등록 정보
   * @returns 성공 시 void, 실패 시 SATError
   */
  async confirmPreRegistration(uuid: string): Promise<SATResult<void, SATError>> {
    console.log(
      "[PreRegistrationRepositoryImpl] :: confirmPreRegistration :: 사전 등록 정보 수정 시작",
      uuid
    );
    const result = await this.source.confirmPreRegistration(uuid);

    if (result.isSuccess) {
      console.log(
        "[PreRegistrationRepositoryImpl] :: confirmPreRegistration :: 사전 등록 정보 수정 성공"
      );
      return SATResult.success(void 0);
    } else {
      console.error(
        "[PreRegistrationRepositoryImpl] :: confirmPreRegistration :: 사전 등록 정보 수정 실패",
        result.error
      );
      return SATResult.failure(result.error);
    }
  }

  /**
   * 사전 등록 정보 삭제
   * @param token - 사전 등록 토큰
   * @returns 성공 시 void, 실패 시 SATError
   */
  async deletePreRegistration(uuid: string): Promise<SATResult<void, SATError>> {
    console.log(
      "[PreRegistrationRepositoryImpl] :: deletePreRegistration :: 사전 등록 정보 삭제 시작",
      uuid
    );
    const result = await this.source.deletePreRegistration(uuid);

    if (result.isSuccess) {
      console.log(
        "[PreRegistrationRepositoryImpl] :: deletePreRegistration :: 사전 등록 정보 삭제 성공"
      );
      return SATResult.success(void 0);
    } else {
      console.error(
        "[PreRegistrationRepositoryImpl] :: deletePreRegistration :: 사전 등록 정보 삭제 실패",
        result.error
      );
      return SATResult.failure(result.error);
    }
  }
}
